import moment from 'moment'
import { IImpactForm, IImpactByIdRespDto, IImpactLibraryByIdRespDto } from 'src/types'

const generateFormState = (
  state: IImpactByIdRespDto | IImpactLibraryByIdRespDto,
  code?: string,
) => {
  const initState: IImpactForm = {
    name: state.name,
    code: code ?? '',
    image: {
      icon: state.image || '',
      file: null,
    },
    image_small: state.image_small,
    image_medium: state.image_medium,
    description: state.description,
    period: state.period,
    un_sdg: state.un_sdg,
    media: [],
    selectedSteps: [],
    selectedProducts: [],
    selectedScanners: [],
    quantity: null,
    types: state.types || [],
    quantity_type: null,
    period_start: null,
  }

  if ('media' in state) {
    initState.quantity = state.quantity
    initState.quantity_type = state.quantity_type || state.custom_quantity_type
    initState.media = state.media.map((media) => ({
      ...media,
      file: null,
    }))
    initState.code = code ?? state.code
    initState.selectedSteps = state.steps.map((step) => step.id)
    initState.selectedProducts = state.products.map((product) => product.id)
    initState.selectedScanners = state?.scanners_connections
      ? state.scanners_connections.map((scanner) => scanner.id)
      : []
    initState.period_start = state.period_start ? moment(state.period_start) : null
    initState.types = state.types
  }

  return initState
}

export { generateFormState }
